import React from 'react';
import './about.css';
import CV from '../../assets/Abdulhamid_CV.pdf'
import Info from './Info'
import Lottie from 'lottie-react';

import Contact from '../../../src/animation/about1.json'

const About = () => {
    return(
        <section className="about section" id="about">
            <h2 className="section__title">About Me</h2>
            <span className="section__subtitle">My introduction</span>

            <div className="about__container container grid">
            <Lottie className="Lottie__contact"
                  animationData={Contact} // JSON data of your animation
                  loop={true}
                  autoplay={true}
                />
                <div className="about__data">
                    <Info />

                    <p className="about__description">
                        I'm a full-stack developer specializing in backend and AI systems, with 4+ years of experience including freelance work. I build web applications, REST APIs, conversational voice agents, and retrieval-augmented generation systems with layered architecture, vector search, function calling, and enterprise workflow automation.
                    </p>

                    <a download="" href={CV} className="about__button">Download CV
                    <i className="bx bx-file about__button-icon"></i>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default About;
